import { QueryClient } from '@tanstack/react-query'

import { ApiError } from '@/lib/api'

const ONE_MINUTE = 60_000
const MAX_RETRIES = 2

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: ONE_MINUTE,
      // Retentar um 401 ou um 404 só atrasa o feedback ao usuário.
      retry: (attempt, error) => {
        if (error instanceof ApiError && error.status < 500) return false
        return attempt < MAX_RETRIES
      },
    },
  },
})
